import { Injectable } from '@angular/core';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ILightWeightObject, ILightWeightUser, ILocalSearchDataItemModel } from '@fi-shared/models';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiLinkToType } from '@fi-shared/fi-text-item-helper/fi-link-to-type';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { createMap } from '@fi-shared/utils/create-map';
import { ITextItemLinkModel, ITextItemLinkValue } from '@fi-shared/fi-text-item-helper/fi-text-item-link';
import { ITextPanelMenuItem } from '@fi-shared/fi-text-panel/simple-text-panel/text-panel-base';
import { fiHasAccessToApplicationType } from '@fi-shared/utils';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';
import { safeStartsWith } from '@fi-shared/utils/safe-starts-with';
import { getObjectViewStateData } from '@fi-shared/utils/get-object-view-state-data';
import {
    ChecklistV2LinkMenuItem,
    FormLinkMenuItem,
    MediaLinkMenuItem,
    ColleagueLinkMenuItem,
    DocumentLinkMenuItem,
    EmailLinkMenuItem,
    PhoneNumberLinkMenuItem,
    WebAddressLinkMenuItem,
    ChecklistLinkMenuItem,
    ChecklistV2AuditLinkMenuItem,
} from './text-panel-menu-items-const';

export interface ILinkToType {
    Id: number;
    Name?: string;
    InputTitle?: string;
    extendedSearch?: ILinkToExtendedSearch;
    searchDataSettings?: {
        ObjectType;
        IsWildCardAble: boolean;
        Header?: string;
    };
    LoadSearchData?: (searchData: { Data: ILocalSearchDataItemModel[] }) => void;
    ErrorDialogMessageDeletedItem?: string;
}

interface ILinkToExtendedSearch {
    getValueFromItem: (item) => ITextItemLinkValue;
}

@Injectable()
export class LinkToTypesService {
    WebAddress: ILinkToType;
    Document: ILinkToType;
    UserProfile: ILinkToType;
    Media: ILinkToType;
    Form: ILinkToType;
    CheckList: ILinkToType;
    ChecklistV2: ILinkToType;
    ChecklistV2Audit: ILinkToType;
    Email: ILinkToType;
    Types: ILinkToType[];
    TypesMap: {
        [prop: number]: ILinkToType;
    };

    constructor(
        private appTextService: AppTextService,
        private stateService: FiStateService,
        private userDataService: FiUserDataService,
        private fiBackend: FiBackendService,
    ) {
        this.WebAddress = {
            Id: FiLinkToType.WebAddress,
            /*GetUrl: (model) => {
                const href = model.Value?.Name;
                if (href) {
                    if (href.match(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/img)) {
                        return 'mailto:' + href;
                    }
                    return (new RegExp('^(http|#|/)')).test(href) ? href : 'http://' + href;
                }
                return '';
            }*/
        };

        this.Email = {
            Id: FiLinkToType.Email,
            /*GetUrl: (model) => {
                return 'mailto:' + model.Value?.Name
            }*/
        };

        this.Document = {
            Id: FiLinkToType.Document,
            extendedSearch: {
                getValueFromItem: (document) => {
                    return {
                        Id: document.Id,
                        Name: document.Name,
                        ObjectType: ObjectTypes.Document,
                    };
                },
            },
            searchDataSettings: {
                ObjectType: ObjectTypes.Document,
                IsWildCardAble: false,
            },
            LoadSearchData: (SearchData) => {
                this.getLightWeightDocuments().then((documents) => {
                    SearchData.Data = [];
                    documents.forEach((document) => {
                        SearchData.Data.push({
                            Id: document.Id,
                            Name: document.Name,
                            ObjectType: ObjectTypes.Document,
                        });
                    });
                });
            },
        };

        this.UserProfile = {
            Id: FiLinkToType.UserProfile,
            extendedSearch: {
                getValueFromItem: (user) => {
                    return {
                        Id: user.Id,
                        Name: user.FullName,
                        ObjectType: ObjectTypes.User,
                    };
                },
            },
            searchDataSettings: {
                ObjectType: ObjectTypes.User,
                IsWildCardAble: false,
            },
            LoadSearchData: (SearchData) => {
                this.getLightWeightUsers().then((users) => {
                    SearchData.Data = [];
                    users.forEach((user) => {
                        SearchData.Data.push({
                            Id: user.Id,
                            Name: user.FullName,
                            ObjectType: ObjectTypes.User,
                        });
                    });
                });
            },
        };

        this.Media = {
            Id: FiLinkToType.Media,
            extendedSearch: {
                getValueFromItem: (file) => {
                    return {
                        Id: file.Id,
                        Name: file.Name,
                        ObjectType: ObjectTypes.MediaBank,
                    };
                },
            },
            searchDataSettings: {
                ObjectType: ObjectTypes.MediaBank,
                IsWildCardAble: false,
            },
            LoadSearchData: (SearchData) => {
                this.getLightWeightMediaBankFiles().then((mediaFiles) => {
                    SearchData.Data = [];
                    mediaFiles.forEach((file) => {
                        SearchData.Data.push({
                            Id: file.Id,
                            Name: file.Name,
                            ObjectType: ObjectTypes.MediaBank,
                        });
                    });
                });
            },
        };

        this.Form = {
            Id: FiLinkToType.Form,
            extendedSearch: {
                getValueFromItem: (item) => {
                    return {
                        Id: item.Id,
                        Name: item.Name,
                        ObjectType: ObjectTypes.Form,
                    };
                },
            },
            searchDataSettings: {
                ObjectType: ObjectTypes.Form,
                IsWildCardAble: false,
            },
            LoadSearchData: (SearchData) => {
                // todo do we need this?
            },
        };

        this.CheckList = {
            Id: FiLinkToType.CheckList,
            /*
            GetUrl: (model) => {
                if (model.Value) {
                    return this.stateService.href(FiStateNames.Checklist.View, {Id: model.Value.Id, onlyActive: true});
                }
            },
*/
            extendedSearch: {
                getValueFromItem: (file) => {
                    return {
                        Id: file.Id,
                        Name: file.Name,
                        ObjectType: ObjectTypes.CheckList,
                    };
                },
            },
            searchDataSettings: {
                ObjectType: ObjectTypes.MediaBank,
                IsWildCardAble: false,
            },
            LoadSearchData: (SearchData) => {
                this.getLightWeightCheckLists().then((items) => {
                    SearchData.Data = [];
                    items.forEach((item) => {
                        SearchData.Data.push({
                            Id: item.Id,
                            Name: item.Name,
                            ObjectType: ObjectTypes.CheckList,
                        });
                    });
                });
            },
        };

        this.ChecklistV2 = {
            Id: FiLinkToType.ChecklistV2,
            extendedSearch: {
                getValueFromItem: (item) => {
                    return {
                        Id: item.Id,
                        Name: item.Name,
                        ObjectType: ObjectTypes.Checklist2,
                    };
                },
            },
            searchDataSettings: {
                ObjectType: ObjectTypes.Checklist2,
                IsWildCardAble: false,
            },
        };

        this.ChecklistV2Audit = {
            Id: FiLinkToType.ChecklistV2Audit,
        };

        this.Types = [
            this.WebAddress,
            this.Document,
            this.UserProfile,
            this.Media,
            this.Form,
            this.CheckList,
            this.ChecklistV2,
            this.ChecklistV2Audit,
            this.Email,
        ];

        this.TypesMap = createMap(this.Types, 'Id');

        this.appTextService.textsLoaded$.subscribe(() => this.setAppText());
    }

    getObjectTypeByLinkType(linkToType: FiLinkToType): ObjectTypes {
        if (linkToType === FiLinkToType.Document) return ObjectTypes.Document;

        if (linkToType === FiLinkToType.Media) return ObjectTypes.MediaBank;

        if (linkToType === FiLinkToType.UserProfile) return ObjectTypes.User;

        if (linkToType === FiLinkToType.Form) return ObjectTypes.Form;

        if (linkToType === FiLinkToType.CheckList) return ObjectTypes.CheckList;

        // todo https://chainformation.atlassian.net/browse/FI-5918
        // implement situation when checklist has no connected schedules, in this case we should use
        // ObjectTypes.Checklist2 and ObjectTypes.Checklist2Audit
        if (linkToType === FiLinkToType.ChecklistV2) return ObjectTypes.ChecklistToSchedule;

        if (linkToType === FiLinkToType.ChecklistV2Audit) return ObjectTypes.ChecklistToAuditSchedule;

        return undefined;
    }

    getUrlForItemLinkModel(model: ITextItemLinkModel): string {
        if (!model) return;

        const href: string =
            typeof model.Value === typeof '' ? ((<any>model.Value) as string) : (model.Value?.Name ?? '');
        if (model.Type == FiLinkToType.WebAddress) {
            return !safeStartsWith(href, 'http') ? 'http://' + href : href;
        }

        if (model.Type === FiLinkToType.Email) {
            return 'mailto:' + href;
        }

        if (model.Type === FiLinkToType.PhoneNumber) {
            return 'tel:' + href.replace(/\s/g, '');
        }

        if (model.Value) {
            const objectViewStateData = getObjectViewStateData(model.Value.ObjectType, model.Value.Id);
            const url = this.stateService.href(objectViewStateData.sref, objectViewStateData.srefParams);
            return url;
        }
    }

    private setAppText() {
        this.Email.Name = this.appTextService.get('common.email_address');
        this.Email.InputTitle = this.appTextService.get('common.email_address');

        this.WebAddress.Name = this.appTextService.get('linkto.webaddress');
        this.WebAddress.InputTitle = this.appTextService.get('ccmLinkTo.WebAddressUrl');

        this.Document.Name = this.appTextService.get('common.page');
        this.Document.InputTitle = this.appTextService.get('ccmLinkTo.DocumentTitle');
        this.Document.ErrorDialogMessageDeletedItem = this.appTextService.get('error_message.document_not_found');
        this.Document.searchDataSettings.Header = this.appTextService.get('common.name');

        this.UserProfile.Name = this.appTextService.get('common.UserProfile');
        this.UserProfile.InputTitle = this.appTextService.get('user.user');
        this.UserProfile.ErrorDialogMessageDeletedItem = this.appTextService.get('error_message.user_deleted');
        this.UserProfile.searchDataSettings.Header = this.appTextService.get('common.name');

        this.Media.Name = this.appTextService.get('common.file');
        this.Media.InputTitle = this.appTextService.get('common.file');
        this.Media.searchDataSettings.Header = this.appTextService.get('common.name');

        this.CheckList.Name = this.appTextService.get('common.checklist');
        this.CheckList.InputTitle = this.appTextService.get('common.checklist');
        this.CheckList.searchDataSettings.Header = this.appTextService.get('common.name');
    }

    getLightWeightMediaBankFiles() {
        return this.fiBackend.fetchData<ILightWeightObject[]>('MediaBank/MediaBank/GetLightWeightMediaBankFiles');
    }

    getLightWeightForms() {
        return this.fiBackend.fetchData<ILightWeightObject[]>('Form/Form/GetLightWeightForms');
    }

    getLightWeightUsers() {
        return this.fiBackend.fetchData<Array<ILightWeightUser>>('Core/User/GetUsersForSharing');
    }

    getLightWeightCheckLists() {
        return this.fiBackend.fetchData<ILightWeightObject[]>('CheckList/CheckList/GetLightWeightCheckLists');
    }

    private lightWeightDocuments: Promise<ILightWeightObject[]>;
    getLightWeightDocuments(): Promise<ILightWeightObject[]> {
        if (this.lightWeightDocuments) {
            return this.lightWeightDocuments;
        }
        return (this.lightWeightDocuments = this.fiBackend.fetchData<ILightWeightObject[]>(
            'Document/Document/GetLightWeightDocuments',
        ));
    }

    invalidateDocuments() {
        this.lightWeightDocuments = null;
    }

    getAvailableLinkToItems(isInternalLinksAllowed: boolean = true): ITextPanelMenuItem[] {
        const result: ITextPanelMenuItem[] = [];

        const moduleAccessRights = this.userDataService.userData.ModuleAccessRights;
        if (isInternalLinksAllowed) {
            if (
                fiHasAccessToApplicationType(
                    ApplicationSettingsType.DocumentLocal,
                    AccessRightType.Read,
                    moduleAccessRights,
                )
            ) {
                result.push(DocumentLinkMenuItem);
            }
            if (
                fiHasAccessToApplicationType(
                    ApplicationSettingsType.MediaBankLocal,
                    AccessRightType.Read,
                    moduleAccessRights,
                )
            ) {
                result.push(MediaLinkMenuItem);
            }
            if (
                fiHasAccessToApplicationType(
                    ApplicationSettingsType.CoreLocal,
                    AccessRightType.Read,
                    moduleAccessRights,
                )
            ) {
                result.push(ColleagueLinkMenuItem);
            }
            if (
                fiHasAccessToApplicationType(
                    ApplicationSettingsType.FormLocal,
                    AccessRightType.Read,
                    moduleAccessRights,
                )
            ) {
                result.push(FormLinkMenuItem);
            }
            if (
                fiHasAccessToApplicationType(
                    ApplicationSettingsType.ChecklistV2Local,
                    AccessRightType.Read,
                    moduleAccessRights,
                )
            ) {
                result.push(ChecklistV2LinkMenuItem);
            }
            if (
                fiHasAccessToApplicationType(
                    ApplicationSettingsType.ChecklistV2AuditLocal,
                    AccessRightType.Read,
                    moduleAccessRights,
                )
            ) {
                result.push(ChecklistV2AuditLinkMenuItem);
            }
            if (
                fiHasAccessToApplicationType(
                    ApplicationSettingsType.ChecklistLocal,
                    AccessRightType.Read,
                    moduleAccessRights,
                )
            ) {
                result.push(ChecklistLinkMenuItem);
            }
        }

        result.push(EmailLinkMenuItem);
        result.push(PhoneNumberLinkMenuItem);
        result.push(WebAddressLinkMenuItem);
        return result;
    }
}
